import { getRealTimeNotifications } from './Reducer';
import { useSelector } from 'react-redux';
export const useFloatingNotifications = () => {
  const notifications = useSelector(getRealTimeNotifications);
  return notifications.FLOATING;
};
export const useTeaseNotifications = () => {
  const notifications = useSelector(getRealTimeNotifications);
  return notifications.TEASE;
};
export const useBrowserNotifications = () => {
  const notifications = useSelector(getRealTimeNotifications);
  return notifications.BROWSER;
};
export const useSidebarNotifications = () => {
  const notifications = useSelector(getRealTimeNotifications);
  return notifications.NOTIFICATION_SIDEBAR;
};